import { render, staticRenderFns } from "./faturakalemleri.vue?vue&type=template&id=5297e6ee&scoped=true"
import script from "./faturakalemleri.vue?vue&type=script&lang=js"
export * from "./faturakalemleri.vue?vue&type=script&lang=js"
import style0 from "./faturakalemleri.vue?vue&type=style&index=0&id=5297e6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297e6ee",
  null
  
)

export default component.exports